export default __webpack_public_path__ + "static/media/resolucao-anuidade-2021.1649b06c.pdf";